import { useEffect, useState } from 'react';

export type ScreenResolution = {
  width: number | null;
  height: number | null;
};

export default function useScreenResolution(): ScreenResolution {
  const [resolution, setResolution] = useState<ScreenResolution>({
    width: null,
    height: null,
  });

  useEffect(() => {
    const update = () => {
      setResolution({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    update();
    window.addEventListener('resize', update, { passive: true });
    return () => window.removeEventListener('resize', update);
  }, []);

  return resolution;
}

